import axios from '../utils/axios'

export function login(params) {
    return axios.get('/login', { params });
}

export function logout() {
    return axios.get('/logout');
}

export function checkUserExists(params) {
    const instance = axios.create({
        baseURL: "/"
    });
    return instance.get('/user/getUserBySchool', {params});
}
export function addUser(params) {
    const instance = axios.create({
        baseURL: "/"
    });
    return instance.post('/user/add', params);
}
export function removeUser(params) {
    const instance = axios.create({
        baseURL: "/"
    });
    return instance.post('/user/remove', params);
}
export function getJSConfig() {
    const instance = axios.create({
        baseURL: "/"
    })
    return instance.get('/wx/getSign');
}